import React from "react";
// import { DropdownButton, Dropdown, Form } from "react-bootstrap";

export const GlobalFilter = ({ filter, setFilter }) => {
  // const handleSelect = (e) => {
  //   console.log(e);
  //   setFilter(e)
  // };

  return (
    <div>
      <span>
        <input
          type="search"
          name="search"
          placeholder="Search Here"
          value={filter || ""}
          onChange={(e) => setFilter(e.target.value)}
          style={{
            width: "200px",
            padding: "10px",
            border: "1px solid #1D3FAA",
            borderRadius: "20px",
            outline: "none",
          }}
        />
      </span>
      {/* <DropdownButton title={<i class="bi bi-funnel"></i>} id="dropdown-menu-align-right" onSelect={handleSelect}>
        <Dropdown.Item eventKey="Teacher">
          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Check type="checkbox" label="Teachers" />
          </Form.Group>
        </Dropdown.Item>

        <Dropdown.Item eventKey="Student">
          {" "}
          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Check type="checkbox" label="Students" />
          </Form.Group>
        </Dropdown.Item>
      </DropdownButton> */}
    </div>
  );
};
